import { Chip, SxProps, useTheme } from "@mui/material";

type ThresholdChipProps = {
  isOverThreshold: boolean | null | undefined;
  loading?: boolean;
  sx?: SxProps;
};

export function ThresholdChip({ isOverThreshold, sx }: ThresholdChipProps) {
  const theme = useTheme();
  const backgroundColor = isOverThreshold
    ? `${theme.palette.error.light}20`
    : `${theme.palette.success.light}20`;

  const color = isOverThreshold
    ? theme.palette.error.main
    : theme.palette.success.main;

  return isOverThreshold == undefined ? (
    <Chip
      label={<span style={{ width: 100 }}>... Threshold</span>}
      size="small"
      variant="filled"
      sx={{
        backgroundColor: theme.palette.grey50.dark,
        color: theme.palette.grey50.main,
        ...sx,
      }}
    ></Chip>
  ) : (
    <Chip
      label={`${isOverThreshold ? "Above" : "Below"} Threshold`}
      size="small"
      variant="filled"
      sx={{
        backgroundColor,
        color,
        ...sx,
      }}
    />
  );
}
